import {Component, EventEmitter, Input, Output} from "@angular/core";
import {BatchType} from "../../enums/BatchType";
import {AbstractControl, UntypedFormArray, UntypedFormGroup} from "@angular/forms";
import {WorkflowDetailClientService} from "../dialog/workflow-detail-dialog/workflow-detail-client.service";

@Component({
  selector: 'app-batches-selector',
  templateUrl: 'batches-selector.component.html',
  styleUrls: ['batches-selector.component.scss']
})
export class BatchesSelectorComponent {
  BatchType = BatchType;

  @Input() forms: UntypedFormArray;
  @Input() readOnly: boolean = false;
  @Input() showExpirationDate: boolean = true;
  @Output() onChange = new EventEmitter();

  constructor(private workflowDetailClientService: WorkflowDetailClientService) {
  }

  getFormGroupFromAbstractControl(form: AbstractControl): UntypedFormGroup {
    return form as UntypedFormGroup;
  }

  getBatchNumber(form: AbstractControl) {
    return this.getFormGroupFromAbstractControl(form).get('batch')?.value?.batchNumber;
  }

  getBatchType(form: AbstractControl) {
    return this.getFormGroupFromAbstractControl(form).get('type')?.value;
  }

  showType(index: number, skipCheck: boolean = false): boolean {
    if (skipCheck) return true;
    if (index === 0) return true;
    const currentType = this.getBatchType(this.formsSorted[index]);
    const previousType = this.getBatchType(this.formsSorted[index - 1]);
    return currentType !== previousType;
  }

  getPlatesSuffixes(form: AbstractControl): string {
    const batch = this.getFormGroupFromAbstractControl(form).get('batch')?.value;
    if (batch && batch.plates && batch.plates.length > 0) {
      return batch.plates.map((p: any) => p.suffix).filter((s: string) => !!s).join(', ');
    }
    return '';
  }

  get formsSorted(): AbstractControl[] {
    if (!this.forms?.controls) return [];
    return [...this.forms.controls].sort((a, b) => {
      const typeA = this.getBatchType(a);
      const typeB = this.getBatchType(b);
      if (typeA !== typeB) {
        return typeA > typeB ? 1 : -1;
      }
      const nameA = this.getBatchNumber(a) || '';
      const nameB = this.getBatchNumber(b) || '';
      return nameA.localeCompare(nameB);
    });
  }

  debounceTimer: number = null;

  onSomeChange() {
    // Clear the existing timer if there is one
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timer
    // @ts-ignore
    this.debounceTimer = setTimeout(() => {
      this.onChange.emit();
    }, 100); // Wait for 100ms of inactivity then emit the onchange and save silently
  }

}
